module.exports = __webpack_public_path__ + "img/pix-icon.83d028fb.svg";